import { render, staticRenderFns } from "./CrmLeadContact.vue?vue&type=template&id=07bb5170&scoped=true&"
import script from "./CrmLeadContact.vue?vue&type=script&lang=js&"
export * from "./CrmLeadContact.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadContact.vue?vue&type=style&index=0&id=07bb5170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb5170",
  null
  
)

export default component.exports